import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-059316f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ms_label = _resolveComponent("ms-label")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.cssCls)
  }, [
    _createVNode(_component_ms_label, {
      style: _normalizeStyle(_ctx.labelStyle),
      required: !_ctx.allowBlank
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }, 8, ["style", "required"]),
    _createVNode(_component_el_select, {
      "model-value": _ctx.value,
      disabled: !_ctx.editable,
      clearable: _ctx.clearable,
      "clear-icon": _ctx.clearIcon,
      size: _ctx.size,
      placeholder: _ctx.placeholder,
      "default-first-option": "",
      filterable: "",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = (event) => _ctx.updateModel(event)),
      onChange: _cache[1] || (_cache[1] = (event) => _ctx.onChange(event)),
      onBlur: _cache[2] || (_cache[2] = (event) => _ctx.onBlur(event)),
      onFocus: _cache[3] || (_cache[3] = (event) => _ctx.onFocus(event)),
      "allow-create": _ctx.allowCreate,
      "validate-create": _ctx.validateCreate
    }, {
      prefix: _withCtx(() => [
        _createElementVNode("i", {
          class: _normalizeClass(`el-input__icon ${_ctx.prefixIcon}`)
        }, null, 2)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.value,
            value: item.value,
            disabled: item.disabled
          }, null, 8, ["label", "value", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value", "disabled", "clearable", "clear-icon", "size", "placeholder", "allow-create", "validate-create"]),
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "error-msg",
          innerHTML: _ctx.errorMessage
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}